import React, { useState, useEffect } from "react";
import API from "../../../api";
import "./comment.css";

export default function CommentsModal({ post, onClose }) {

  const [comments, setComments] = useState([]);
  const [text, setText] = useState("");

  const currentUser = JSON.parse(localStorage.getItem("civilink_user"));

  /* ================= LOAD COMMENTS ================= */
  useEffect(() => {
    loadComments();
  }, []);

  const loadComments = async () => {
    try {

      const res = await API.get(`/comments/${post._id}`);

      setComments(res.data.comments || []);

    } catch (err) {
      console.error("Load comments error:", err);
    }
  };

  /* ================= ADD COMMENT ================= */

  const addComment = async () => {

    if (!text.trim()) return;

    try {

      const res = await API.post(`/comments/${post._id}`, {
        text
      });

      setComments([res.data, ...comments]);

      setText("");

    } catch (err) {
      console.error("Add comment error:", err);
    }
  };

  /* ================= LIKE COMMENT ================= */

  const likeComment = async (id) => {

    try {

      await API.post(`/comments/like/${id}`);

      loadComments();

    } catch (err) {
      console.error("Like comment error:", err);
    }
  };

  /* ================= DELETE COMMENT ================= */

  const deleteComment = async (id) => {

    if (!window.confirm("Delete this comment?")) return;

    try {

      await API.delete(`/comments/${id}`);

      setComments(comments.filter(c => c._id !== id));

    } catch (err) {
      console.error("Delete comment error:", err);
    }
  };

  /* ================= EDIT COMMENT ================= */

  const editComment = async (comment) => {

    const newText = prompt("Edit comment", comment.text);

    if (!newText || !newText.trim()) return;

    try {

      await API.put(`/comments/${comment._id}`, {
        text: newText
      });

      loadComments();

    } catch (err) {
      console.error("Edit comment error:", err);
    }
  };

  /* ================= UI ================= */

  return (

    <div className="modal-backdrop" onClick={onClose}>

      <div
        className="modal-card"
        onClick={e => e.stopPropagation()}
      >

        <h3>Comments</h3>

        <div className="comments-list">

          {comments.length === 0 && (
            <div className="empty-small">
              No comments yet
            </div>
          )}

          {comments.map(c => (

            <div key={c._id} className="comment-item">

              <img
                src={c.user?.profilePhoto || "/default-avatar.png"}
                alt={c.user?.name || "user"}
                className="comment-avatar"
              />

              <div className="comment-body">

                <strong>{c.user?.name}</strong>

                <p>{c.text}</p>

                <div className="comment-actions">

                  <button
                    onClick={() => likeComment(c._id)}
                  >
                    👍 {c.likes?.length || 0}
                  </button>

                  {/* SHOW EDIT + DELETE ONLY FOR OWNER */}

                  {currentUser?._id === c.user?._id && (

                    <>

                      <button
                        className="comment-edit"
                        onClick={() => editComment(c)}
                      >
                        ✏ Edit
                      </button>

                      <button
                        className="comment-delete"
                        onClick={() => deleteComment(c._id)}
                      >
                        🗑 Delete
                      </button>

                    </>

                  )}

                </div>

              </div>

            </div>

          ))}

        </div>

        <textarea
          placeholder="Write comment..."
          value={text}
          onChange={e => setText(e.target.value)}
        />

        <button
          className="btn primary"
          onClick={addComment}
        >
          Post
        </button>

      </div>

    </div>

  );

}